import { createReducer, on } from '@ngrx/store';
import { Page } from '../../../domain/page';
import * as Actions from './page-selector.actions';

export const featureKey = 'cxbPageSelector';

export interface FeatureState {
  pages: Page[];
  loading: boolean;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  pages: [],
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(Actions.fetchPages, (state): FeatureState => ({ ...state, pages: [], loading: true })),
  on(Actions.fetchPagesSuccess, (state, action): FeatureState => ({ ...state, loading: false, pages: action.pages })),
  on(Actions.fetchPagesFail, (state): FeatureState => ({ ...state, pages: [], loading: false }))
);
